import { ContentCompact, Section } from '@ferreri/prever-component-lib';
import { ReactNode, useMemo, useState } from 'react';

import { CurrentGeoLocationCardButton } from './CurrentGeoLocationCardButton';
import { CurrentAccountLocationCardButton } from './CurrentAccountLocationCardButton';
import { LocationSearchForm } from './LocationSearchForm';
import { LocationList } from './LocationList';
import { useDebouncedGeocode } from '@modules/geolocation/geolocation.store';

type LocationBaseProps = {
  children: ReactNode;
};

const LocationBase = (props: LocationBaseProps) => {
  const [isSearching, setIsSearching] = useState(false);
  const [address, setAddress] = useState('');
  const { data: geocode, isFetching } = useDebouncedGeocode({ address });
  const isEmpty = !address || geocode?.results?.length === 0;
  const items = useMemo(
    () =>
      geocode?.results?.map((item) => ({
        address: item.formatted_address,
        latitude: item.geometry.location.lat,
        longitude: item.geometry.location.lng,
      })),
    [geocode?.results],
  );

  return (
    <ContentCompact>
      <>{props.children}</>

      <Section>
        <LocationSearchForm
          isSearching={isSearching}
          setIsSearching={setIsSearching}
          setAddress={setAddress}
        />
        {isSearching ? (
          <LocationList
            isEmpty={isEmpty}
            isFetching={isFetching}
            items={items}
          />
        ) : (
          <Section>
            <CurrentGeoLocationCardButton />
            <CurrentAccountLocationCardButton />
          </Section>
        )}
      </Section>
    </ContentCompact>
  );
};

export default LocationBase;
